/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ProfileNoteResponseViewerReaction = typeof ProfileNoteResponseViewerReaction[keyof typeof ProfileNoteResponseViewerReaction] | null;


export const ProfileNoteResponseViewerReaction = {
  like: 'like',
  dislike: 'dislike',
} as const;
